<template>
<div>
  <b-card>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="bestofLeaderResultsGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'bestofLeaderResultsGrid',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'campaign_id',
        modal:'bestof-modal',
        foreign: 'id',
        placeholder: 'Campanha'
      }, {
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }, {
        field:'zone',
        modal:'zones-modal',
        foreign: 'zone',
        placeholder: 'Zona'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }, {
        api: 'dsr/lst',
        field: 'dsr_id'
      }, {
        api: 'bestof/campaigns/lst',
        field: 'campaign_id'
      }],
      url: 'bestof/resultsleader',
      columns: [{
        field: 'campaign_id',
        title: 'Campanha',
        width: '220px'
      },
      {
        field: 'dsr_id',
        title: 'DSR',
        width: '220px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '220px'
      },
      {
        field: 'zone',
        title: 'Zona',
        width: '120px'
      },
      {
        field: 'value',
        title: 'Valor',
        width: '120px'
      },
      {
        field: 'success_value',
        title: 'Valor OK',
        width: '120px',
        values: lists.yesNo
      },
      {
        field: 'operators',
        title: 'Operadores',
        width: '120px'
      },
      {
        field: 'success_operators',
        title: 'Operadores OK',
        width: '120px',
        values: lists.yesNo
      },
      {
        field: 'quantity',
        title: 'Quantidade',
        width: '120px'
      },
      {
        field: 'success_quantity',
        title: 'Quantidade OK',
        width: '120px',
        values: lists.yesNo
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>
